function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 7C4 6.72386 4.22386 6.5 4.5 6.5H19.5C19.7761 6.5 20 6.72386 20 7V7.5C20 7.77614 19.7761 8 19.5 8H4.5C4.22386 8 4 7.77614 4 7.5V7Z",
  fill: "#86ACD2"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 11.5C4 11.2239 4.22386 11 4.5 11H16.5C16.7761 11 17 11.2239 17 11.5V12C17 12.2761 16.7761 12.5 16.5 12.5H4.5C4.22386 12.5 4 12.2761 4 12V11.5Z",
  fill: "#86ACD2"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4 16.5C4 16.2239 4.22386 16 4.5 16H19.5C19.7761 16 20 16.2239 20 16.5V17C20 17.2761 19.7761 17.5 19.5 17.5H4.5C4.22386 17.5 4 17.2761 4 17V16.5Z",
  fill: "#86ACD2"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.2845 11.5055C22.5793 11.6529 22.5793 12.0736 22.2845 12.2211L18.5789 14.0738C18.3129 14.2068 18 14.0134 18 13.7161L18 10.0105C18 9.71314 18.3129 9.51974 18.5789 9.65272L22.2845 11.5055Z",
  fill: "#86ACD2"
});
const SvgCharacteristicIconClose = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCharacteristicIconClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/characteristicIconClose.e7dd040a.svg";
export { ForwardRef as ReactComponent };